import { sortCaret, IconeDelete } from '../../comum/components/Icones'
import { observable } from 'mobx'
import React from "react";
import { Button, Row } from "reactstrap";
import VeiculoService from '../../../services/VeiculoService'
import { formatarDataDireto, formatNavioViagemComBarra } from '../../../utils/formatar';
import moment from 'moment';


export default class VeicCdtaStore {

    @observable colunas;
    @observable itens;
    @observable listaAguard;
    @observable loadingListaAguard;
    @observable showModalAnexo;
    @observable listaAnexos;
    @observable mensagemVeic;
    @observable mostrarAnexos;
    @observable anexosGerenciar;
    @observable carregandoAnexosGerencia;
    @observable posicionamentos;
    @observable posCntr;

    constructor() {
        this.colunas = this.todasColunas;
        this.itens = [];
        this.listaAguard = [];
        this.listaAnexos = [];
        this.anexosGerenciar = [];
        this.posicionamentos = [{label: "DEPARTED ", value: "DEPARTED "}, {label: "YARD", value: "YARD"}, {label: "LOADED", value: "LOADED"}];

        this.mostrarAnexos = false;
        this.loadingListaAguard = false;
        this.carregandoAnexosGerencia = false;
        this.showModalAnexo = false;
        this.mensagemVeic = "";

        this.cdtaSelecionado = null


        /* Anexos */
        this.dataAtend = null;
        this.placa = "";
        this.container = "";
        this.booking = "";
        this.posCntr = "";

        /* Download */
        this.download = document.createElement('a');
        document.body.appendChild(this.download);
        this.download.style = "display: none";
        this.download.target = "_blank";



        this.service = new VeiculoService();

        this.listar();
    }

    /* Anexos */

    filtrarAnexos = () => {
        this.carregandoAnexosGerencia = true;
        this.service.GerenciarAnexos(this.dataAtend, this.placa, this.container, this.booking, this.posCntr ? this.posCntr.value : "").then(response => {
            if(response && response.data) {
                this.anexosGerenciar = response.data;
            }
        }).catch(err => {
            console.error(err)
        }).finally(() => {
            this.carregandoAnexosGerencia = false;
        });
    }

    toogleAnexos = () => {
        this.mostrarAnexos = !this.mostrarAnexos;
    }

    setDataAtend = (value) => {
        this.dataAtend = value;
    }
    
    setPlaca = (value) => {
        this.placa = value;
    }
    
    setContainer = (value) => {
        this.container = value;
    }

    setBooking = (value) => {
        this.booking = value;
    }

    setPosCntr = (value) => {
        this.posCntr = value;
    }

    /* Fim Anexos */

    listar = () => {
        this.loadingListaAguard = true

        this.service.ListarAguardandoCdta().then(response => {
            if(response && response.data){
                this.listaAguard = response.data;
            }
            //TODO retirar isso ao fazer o infinite scroll
            this.itens = this.listaAguard;
        }).catch(err => console.log(err)
        ).finally(() => this.loadingListaAguard = false)
    }

    excluirAnexo = (row) => {
        this.service.exlcuirAnexos(row.Anexos.map(anexo => anexo.Id)).then((response => {
            if(response && response.data) {
                this.mensagemVeic = response.data.MensagemErro;
            } else {
                this.mensagemVeic = "Houve um erro ao tentar excluir o anexo";
            }
        })).catch((err) => console.error(err));
    }
    
    fecharModalMensagem = () => {
        this.mensagemVeic = "";
        this.listar();
    }

    renderBtnAnexo = (row) => {
        if(!row) return null
        if(row.Anexos && row.Anexos.length > 0 ){
            return(
                <Row className="align-items-center">
                    {`${row.Anexos[0].DscArquivo}.${row.Anexos[0].ArquivoExtensao}`}
                </Row>
            )
        }else{
            return(
                <Button onClick={() => this.mostrarModalAnexo(row)} className="px-2 btn-com-bordas-primary">Anexar</Button>
            )
        }
    }

    renderAnexo = (row) => {
        return(
            <Row className="align-items-center">
                {`${row.Anexos[0].DscArquivo}.${row.Anexos[0].ArquivoExtensao}`}
            </Row>
        )
    }

    baixarAnexo = (row) => {
        if(row.Anexos[0].ArquivoExtensao === "pdf") {
            this.download.href = 'data:application/octet-stream;base64,' + row.Anexos[0].Arquivo;
            this.download.download = `${row.Anexos[0].DscArquivo}.${row.Anexos[0].ArquivoExtensao}`;
            this.download.click();
        } else {
            const file = new File([atob(row.Anexos[0].Arquivo)], `${row.Anexos[0].DscArquivo}.${row.Anexos[0].ArquivoExtensao}`,{ type: "octet/stream;charset=UTF-8" });        
            const url = window.URL.createObjectURL(file);
            this.download.href = url;
            this.download.download = `${row.Anexos[0].DscArquivo}.${row.Anexos[0].ArquivoExtensao}`;
            this.download.click();
            window.URL.revokeObjectURL(url);
        }
    }

    mostrarModalAnexo = (row) => {
        this.cdtaSelecionado = row
        this.showModalAnexo = true
    }

    fecharModalAnexo = () => {
        this.cdtaSelecionado = null
        this.showModalAnexo = false
    }

    anexarArquivos = (event) => {
        // Como só aceitamos 1 arquivo atualmente, vamos limpar o array sempre que entrar no anexar arquivos
        this.listaAnexos = []
        Array.from(event.target.files).map(arqv => {
            let filename = arqv.name.replace(/[^a-zA-Z0-9\.]/g, "");
            filename = filename.split('.')[0];
            this.listaAnexos.push(
                {
                    file: arqv,
                    extensao:arqv.name.split('.').pop(),
                    dscArquivo:filename,
                    placaVeic: this.cdtaSelecionado.PlacaVeic,
                    bookingNbr: this.cdtaSelecionado.NumBooking,
                    tvdtlsGkey: this.cdtaSelecionado.TvdtlsGkey,
                    appoitmentNbr: this.cdtaSelecionado.AppointmentNbr
                }
            )
        })
    }

    enviarAnexo = () => {

        this.listaAnexos.map(arq => {
            this.service.Salvar(arq).then( response => {
                    }
                ).catch(err => console.log(err))
            }
        )
    }

    todasColunas = [
        {
            text: "Container",
            dataField: "CodCntr",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left',
        },
        {
            text: "Placa",
            dataField: "PlacaVeic",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left',
        },
        {
            text: "Navio/Viagem",
            dataField: "NavioViagem",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left',
            formatter: formatNavioViagemComBarra
        },
        {
            text: "Booking",
            dataField: "NumBooking",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left',
        },
        {
            text: "Atendimento",
            dataField: "HoraAtend",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left',
            formatter: formatarDataDireto
        },
        {
            dataField: 'Anexos',
            isDummyField: true,
            text: "Anexo",
            headerAlign: 'left',
            formatter: (cell, row) => this.renderBtnAnexo(row),
            //cardFormatter: (cell, row) => this.renderAcaoBtn(row, "Enviar"),
        }
    ]

    colunasAnexos = [
        {
            text: "Container",
            dataField: "CodCntr",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left',
        },
        {
            text: "Placa",
            dataField: "PlacaVeic",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left',
        },
        {
            text: "Navio/Viagem",
            dataField: "NavioViagem",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left',
            formatter: formatNavioViagemComBarra
        },
        {
            text: "Booking",
            dataField: "NumBooking",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left',
        },
        {
            text: "Posicionamento",
            dataField: "PosCntr",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left',
        },
        {
            text: "Atendimento",
            dataField: "DatAtend",
            sort: true,
            sortCaret: sortCaret,
            headerAlign: 'left',
            formatter: formatarDataDireto
        },
        {
            dataField: 'Anexos',
            isDummyField: true,
            text: "Anexo",
            headerAlign: 'left',
            formatter: (cell, row) => this.renderAnexo(row),
            //cardFormatter: (cell, row) => this.renderAcaoBtn(row, "Enviar"),
        },
        {
            dataField: 'Anexos',
            isDummyField: true,
            text: "Download",
            headerAlign: 'left',
            formatter: (cell, row) => <Button onClick={() => this.baixarAnexo(row)} className="px-2 btn-com-bordas-primary">Baixar</Button>,
            //cardFormatter: (cell, row) => this.renderAcaoBtn(row, "Enviar"),
        }
    ]

}



// WEBPACK FOOTER //
// ./src/modules/veiculoscdta/stores/VeicCdtaStore.js